import * as moment from 'moment';
import * as Mutations from './mutations';
import { UserData } from '@/common/auth/user-data';
import { MOMENT_BACKEND_DATE_FORMAT } from '@/constants/dateFormats';
import { SchoolActivityCalendarService } from '@/common/services/pages/activity-calendar.service';
import { getEndMonthDate, getEndWeekDate, getStartMonthDate, getStartWeekDate } from '@/common/utils/dates';

export const ActivityCalendarModule = {
    state: {
        mode: 'Month',
        calendarDate: new Date(),
        ClassDatesList: {},
        CampDatesList: {},
        AftercareDatesList: {}
    },

    mutations: {
        [Mutations.SET_ACTIVITY_CALENDAR_DATES](state, { data, activityType }) {
            state[`${activityType}DatesList`] = {
                ...state[`${activityType}DatesList`],
                ...data
            }
        },

        [Mutations.SET_ACTIVITY_CALENDAR_DATE](state, calendarDate) {
            state.calendarDate = calendarDate;
        },

        [Mutations.SET_ACTIVITY_CALENDAR_MODE](state, mode) {
            state.mode = mode;
        },

        [Mutations.RESET_ACTIVITY_CALENDAR_DATES](state) {
            state.ClassDatesList = {};
            state.CampDatesList = {};
            state.AftercareDatesList = {};
        }
    },

    actions: {
        async getActivitiesCalendar(context, { activityType, schoolId }) {
            let dateFrom, dateTo;
            const { calendarDate, mode } = context.state;

            if (mode === 'Month') {
                dateFrom = getStartMonthDate(calendarDate);
                dateTo = getEndMonthDate(calendarDate);
            } else {
                dateFrom = getStartWeekDate(calendarDate);
                dateTo = getEndWeekDate(calendarDate);
            }

            dateFrom = moment(dateFrom).format(MOMENT_BACKEND_DATE_FORMAT);
            dateTo = moment(dateTo).format(MOMENT_BACKEND_DATE_FORMAT);
            const { data } =
                UserData.getUserDataFromLocalStorage()
                    ? await SchoolActivityCalendarService[`get${activityType}DatesCheckRole`](schoolId, dateFrom, dateTo)
                    : await SchoolActivityCalendarService[`get${activityType}Dates`](schoolId, dateFrom, dateTo);

            context.commit(Mutations.SET_ACTIVITY_CALENDAR_DATES, { data, activityType });
        },


        changeActivityCalendarDate(context, calendarDate) {
            context.commit(Mutations.SET_ACTIVITY_CALENDAR_DATE, calendarDate);
        },

        changeActivityCalendarMode(context, mode) {
            context.commit(Mutations.SET_ACTIVITY_CALENDAR_MODE, mode);
        },

        resetActivitiesCalendar(context) {
            context.commit(Mutations.RESET_ACTIVITY_CALENDAR_DATES);

        }
    },

    getters: {
        activityCalendarDate: state => state.calendarDate,

        activityCalendarMode: state => state.mode,

        getActivitiesByDate: state => activityType => day => {
            const date = moment(day).format(MOMENT_BACKEND_DATE_FORMAT);
            const activities = state[`${activityType}DatesList`][date];
            return activities ?
                [...activities.map(activity => {
                    const [fromHours, fromMinutes] = activity.timeFrom.split(':');
                    const [toHours, toMinutes] = activity.timeTo.split(':');
                    return {
                        ...activity,
                        timeFrom: moment(date).hours(fromHours).minutes(fromMinutes).toDate(),
                        timeTo: moment(date).hours(toHours).minutes(toMinutes).toDate()
                    }
                })] :
                [];
        },

        getActivitiesByDateAndTime: (state, getters) => activityType => (day, timeFrom) => {
            const getActivitiesByDate = getters.getActivitiesByDate(activityType);
            const previousDate = moment(day).subtract(1, 'day').toDate();
            const notEndedActivitiesStartedOn = getNotEndedActivitiesStartedOnDay(previousDate, timeFrom, getActivitiesByDate);
            const currentDateActivities = getActivitiesByDate(day)
                .filter(activity => activityBelongsToTimeInterval(activity, timeFrom));

            return [...currentDateActivities, ...notEndedActivitiesStartedOn];
        }
    }
};

function activityBelongsToTimeInterval(activity, timeFrom) {
    return moment(timeFrom).date(activity.timeFrom.getDate()).month(activity.timeFrom.getMonth()).year(activity.timeFrom.getFullYear())
            .isSame(activity.timeFrom, 'hours') &&
        moment(timeFrom).date(activity.timeFrom.getDate()).month(activity.timeFrom.getMonth()).year(activity.timeFrom.getFullYear()).add(1, 'hours')
            .isSameOrAfter(activity.timeFrom, 'hours');
}

function getNotEndedActivitiesStartedOnDay(day, timeFrom, getter) {
    let result = [];
    if (moment(timeFrom).hours() === 0) {
        const previousDateActivities = getter(day)
            .filter(activity => moment(activity.timeFrom).isAfter(activity.timeTo, 'hours'));
        result.push(...previousDateActivities);
    }
    return result;
}




// WEBPACK FOOTER //
// ./src/store/modules/activity-calendar/activity-calendar.module.js